"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForecastsCopyToOfferedResultSchema = void 0;
const zod_1 = require("zod");
/**
 * Schema describing the result of copying forecasts into offered volumes. The result is a dictionary whose keys are
 * forecast IDs and whose values are their copy statuses.
 */
exports.ForecastsCopyToOfferedResultSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.object({
    success: zod_1.z.boolean(),
    message: zod_1.z.string().min(1).optional(),
}));
